import { ElementRef, EventEmitter, HostListener, Output, ViewChild } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-fixed-bar',
  templateUrl: './fixed-bar.component.html',
  styleUrls: ['./fixed-bar.component.scss'],
})


export class FixedBarComponent implements OnInit {
  @ViewChild('stickyMenu') menuElement: ElementRef;
  @Input() participation: any;
  @Input() disabled: boolean;
  @Output() save = new EventEmitter<string>();
  @Output() showButton = new EventEmitter<boolean>();
  menuPosition: any;
  sticky: boolean = false;
  
  @HostListener('window:scroll', ['$event'])
    handleScroll(){
        const windowScroll = window.pageYOffset;
        if(windowScroll >= this.menuPosition && this.participation && this.participation.saldoContable){
            this.sticky = true;
        } else {
            this.sticky = false;
        }
        this.showButton.emit(!this.sticky);
    }
    
  constructor() {}

  ngAfterViewInit(){
    this.menuPosition = this.menuElement.nativeElement.offsetTop  
  }

  ngOnInit() {}

  next() {
    this.save.emit();
  }
}
